import { useState } from "react";
import { useEffect } from "react";
import { connect } from "react-redux";
import { Button } from "reactstrap";
import { Row, Col, Container } from "reactstrap";
import { Field, InjectedFormProps, getFormValues, reduxForm } from "redux-form";

import { AxiosError } from "axios";
import Service from "../../../../services";
import { catchError } from "../../../../utils/Utils";
import { postQuestionData } from "../../../../models/ClientPortalCategoriesDetails/CategoriesDetails";
import FinSpinner from "../../../../commonfields/FinSpinner";
import { Navigate, useLocation, useNavigate, useParams } from "react-router-dom";
import { SingleSelectionBox } from "common-fields";
import { AssistScrren2 } from "./AssistScreen2";
import { RoutesEnum } from "../../../../utils/RoutesUtil";




function CompanySelection(props: any) {

  const [welcomeQuestion, setWelcomeQuestion] = useState<any>()
  const service = new Service();
  const [updateBtn, setUpdateBtn] = useState<boolean>(false)
  const [loader, setloader] = useState<boolean>(false);
  const { clientId, clientProductId } = useParams();
  const [redirect, setRedirect] = useState<boolean>(false)
  const location = useLocation();
  const navigate = useNavigate()
  const { screenType } = useParams();

  const name =
    "question_" +
    welcomeQuestion?.questionId.toString();

  useEffect(() => {
    service.getFirstQuestion(clientProductId).then((response: any) => {
      setWelcomeQuestion(response.data)
    }).catch((error: AxiosError) => {
      catchError(error, true);
    })
  }, [])


  useEffect(() => {
    if (
      props?.formValues &&
      Object.keys(props?.formValues)?.length > 0 &&
      props?.formValues?.[name] &&
      props.formValues?.[name]?.length > 0
    ) {
      setUpdateBtn(false)
    }
    else setUpdateBtn(true)
  }, [name, props.formValues]);

  // const cancelUpdation = () => {
  //   props.changeData(false);
  // };

  const changeStatus = async () => {
    const ans: any = Object.values(props.formValues)
    const postQuestionData1: postQuestionData = {
      answer: "",
      clientQuestionId: welcomeQuestion?.clientQuestionId,
      clientId: clientId,
      options: [
        {
          questionOptionId: ans[0],
          answer: ans[0],
        },
      ],
      requireCopy: false,
      businessTypeChange: false,
      clientProductId: clientProductId
    };

    // change this
    // const destination = `/${RoutesEnum.CLIENT_QUESTIONARIE}/${screenType}/${clientId}/${clientProductId}`;
    //  navigate(destination,location?.state);
    // window.location.reload();

    setloader(true);
    try {
      await service.postSaveWelcomeClientResponse(postQuestionData1)
      props.refreshComponent();
      setloader(false);
      window.location.reload()

    }
    catch (error) {
      catchError(error, true);
      setloader(false)
    }



  }
  return (
    <>
      {redirect && <Navigate to={`/${RoutesEnum.CLIENT_QUESTIONARIE}/${screenType}/${clientId}/${clientProductId}`} state={location?.state} />}
      <Container fluid className="WelcomeWrapper page-2 ">
        <form>
          <Row>
            <Col md="12" className="csCard">
              <AssistScrren2 />
            </Col>

            <Col md="12" className="QualIntro">
              <Field
                component={SingleSelectionBox}
                name={"question_" + welcomeQuestion?.questionId.toString()}
                label={welcomeQuestion?.questionText}
                helpText={welcomeQuestion?.helpText}
                options={welcomeQuestion?.options.sort(
                  (a: any, b: any) => a.value - b.value
                )}
              />
            </Col>
          </Row>
        </form>
        <div className="text-center">
          <Button disabled={updateBtn} onClick={() => { changeStatus() }} className="StartBtn">Start Application</Button>
        </div>
        {loader ? <FinSpinner /> : ""}
      </Container>
    </>
  );
}

export default connect((state: any) => {
  return {
    formValues: getFormValues("companySelection")(state),
  };
})(
  reduxForm<Record<any, unknown>, any>({
    form: "companySelection",
  })(CompanySelection)
);
